import{f as n}from"./__vite-currency.wZBLyXyz.js";import{e as v}from"./__vite-utils.B5189NUM.js";class y extends HTMLElement{constructor(){super(),this.itemsCount=null,this.headerPrice=null,this.stickyPrice=null,this.product=null,this.variant=null,this._subtotal=0,this._shipping=0,this._totalItems=0,this._bundles=[],this._addOns=[],this._addOns2=[],this._variantUpsells=[],this.total=0,this.cart={cartSubtotal:0,cartTotal:0,cartLines:[]}}connectedCallback(){this.itemsCount=this.querySelector('[js-product-summary="count"]'),this.headerPrice=this.querySelector('[js-product-summary="headerPrice"]'),this.stickyPrice=document.querySelector('[js-product-form="sticky-price"]'),this.summaryControl=this.querySelector(".product-summary__control"),this.summaryControl=this.querySelector(".product-summary__control"),this.variantLine=this.querySelector('[js-product-summary="variant"]'),this.getVariantOnLoad(),this.setEventListeners(),this.updateTotal()}set subtotal(t){this._subtotal=t,this.updateTotal()}get subtotal(){return this._subtotal}get bundles(){return this._bundles}get variantUpsells(){return this._variantUpsells}get addOns(){return this._addOns}get addOns2(){return this._addOns2}set shipping(t){this._shipping=t,this.updateTotal()}get shipping(){return this._shipping}get totalItems(){return this._totalItems}bundlesSetter(t){this._bundles=t,this.updateVariantLine()}variantUpsellsSetter(t){const{variant:s,selected:e}=t;e?this._variantUpsells=[...this._variantUpsells,s]:this._variantUpsells=this._variantUpsells.filter(a=>(a==null?void 0:a.id)!==(s==null?void 0:s.id)),this.updateVariantLine()}addOnsSetter(t){this._addOns=t,this.updateVariantLine()}addOns2Setter(t){this._addOns2=t,this.updateVariantLine()}setEventListeners(){this.summaryControl.addEventListener("click",()=>{this.toggleSummaryPanel()}),document.addEventListener("uwp-variant:update",t=>{const e=t.detail.variant;this.variant=e,this.updateVariantLine()}),v({eventName:"product-upsell:select",action:"listen",callback:t=>{const s=t;this.variantUpsellsSetter(s.detail)}}),v({eventName:"product-upsell:reset",action:"listen",callback:()=>{this._variantUpsells=[],this.updateVariantLine()}})}getVariantOnLoad(){const t=document.querySelector("uwp-product"),s=t==null?void 0:t._selectedVariant;this.product=t==null?void 0:t._product,setTimeout(()=>{const e=t._product;if(s)this.variant=s;else if(e!=null&&e.hasOnlyDefaultVariant){const a=e==null?void 0:e.variants[0];a.title=e==null?void 0:e.title,this.variant=a}this.updateVariantLine()},0)}updateVariantLine(){var o,d,p,m,h;if(!this.variant)return;const t=this.variant.available?window.themeVars.strings.product.stock.inStock:window.themeVars.strings.product.stock.outOfStock,s=this.variant.isPreorder,e=this.variant.preorderDate;let a="",u="";if((o=this.product)!=null&&o.icon_label&&(u=`
        <div class="product-summary__icon-label">
          ${this.product.icon_label.icon?`<img
                src="${this.product.icon_label.icon}"
                width="16"
                height="16"
              />`:""}
          <span class="text-small">
            ${(p=(d=this.product)==null?void 0:d.icon_label)==null?void 0:p.label}
          </span>
        </div>
      `),this.variant.available?a=`
        <div class="product-summary__stock">
          <span class="product-summary__stock-indicator product-summary__stock-indicator--in-stock"></span>
          <span class="product-summary__stock-label">${t}</span>
        </div>
      `:s?a=`
          <div class="product-summary__stock">
            <span class="product-summary__stock-indicator product-summary__stock-indicator--preorder"></span>
            <span class="product-summary__stock-label">${window.themeVars.strings.product.stock.preOrder}</span>
            <span class="product-summary__stock-label">${e}</span>
          </div>
        `:a=`
          <div class="product-summary__stock">
            <span class="product-summary__stock-indicator product-summary__stock-indicator--out-of-stock"></span>
            <span class="product-summary__stock-label">${t}</span>
          </div>
        `,this.variantLine&&this.bundles.length==0){const i=((m=this.variant)==null?void 0:m.compare_at_price)??0,r=this.variant.price,c=i>r;this.variantLine.innerHTML=`
        <div class="product-summary__item product-summary__item-variant">
          <div class="product-summary__item-image-wrapper">
            <img src="${this.variant.imageUrl}" width="72" height="72" class="product-summary__item-image" />
          </div>
          <div class="product-summary__item-content">
            <div class="product-summary__item-details">
              <h6 class="product-summary__item-name text-large">
                ${((h=this.product)==null?void 0:h.title)||this.variant.title}
              </h6>
              ${u}
            </div>
            <div class="product-summary__item-price text-right ${c?"is-on-sale":""}">
              <span>
                <span class="visually-hidden">
                  ${window.themeVars.strings.product.price.sale}
                </span>

                ${c?`<span class="compare-at-price">
                        ${n(i,!0,!1)}
                      </span>`:""}
              </span>

              <span>
                <span class="visually-hidden">
                  ${window.themeVars.strings.product.price.regular}
                </span>
                ${n(r,!0,!1)}
              </span>
            </div>
          </div>
        </div>
        ${a}
      `}if(this.bundles.length>0){const i=this.variant.compare_at_price??0,r=this.variant.price,c=i>r;this.variantLine.innerHTML=this.bundles.map(l=>{var _;return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img src="${(_=l.image)==null?void 0:_.url}" width="72" height="72" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${l.productTitle}
                  </h6>
                  ${a}
                </div>
                ${c&&`<span class="compare-at-price">
                    ${n(i,!0,!1)}
                  </span>`}
                ${n(r,!0,!1)}
              </div>
            </div>
          `}).join("")}this.variantUpsells.length>0&&(this.variantLine.innerHTML+=this.variantUpsells.map(i=>{const r=i.compare_at_price??0,c=i.price,l=r>c;return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img src="${i.imageUrl}" width="72" height="72" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${i.productTitle||i.title}
                  </h6>
                </div>
                <div class="product-summary__item-price text-right ${l?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${l?`<span class="compare-at-price">
                            ${n(r,!0,!0)}
                          </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${n(c,!0,!0)}
                  </span>
                </div>
              </div>
            </div>
            ${a}
          `}).join("")),this.addOns.length>0&&(this.variantLine.innerHTML+=this.addOns.map(i=>{const r=i.compare_at_price??0,c=i.price,l=r>c;return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img src="${i.imageUrl}" width="72" height="72" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${i.productTitle||i.title}
                  </h6>
                </div>
                <div class="product-summary__item-price text-right ${l?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${l?`<span class="compare-at-price">
                            ${n(r,!0,!1)}
                          </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${n(c,!0,!1)}
                  </span>
                </div>
              </div>
            </div>
            ${a}
          `}).join("")),this.addOns2.length>0&&(this.variantLine.innerHTML+=this.addOns2.map(i=>{const r=i.compare_at_price??0,c=i.price,l=r>c;return`
            <div class="product-summary__item product-summary__item-variant">
              <div class="product-summary__item-image-wrapper">
                <img src="${i.imageUrl}" width="72" height="72" class="product-summary__item-image" />
              </div>
              <div class="product-summary__item-content">
                <div class="product-summary__item-details">
                  <h6 class="product-summary__item-name text-large">
                    ${i.productTitle||i.title}
                  </h6>
                </div>
                <div class="product-summary__item-price text-right ${l?"is-on-sale":""}">
                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.sale}
                    </span>

                    ${l?`<span class="compare-at-price">
                          ${n(r,!0,!1)}
                        </span>`:""}
                  </span>

                  <span>
                    <span class="visually-hidden">
                      ${window.themeVars.strings.product.price.regular}
                    </span>

                    ${n(c,!0,!1)}
                  </span>
                </div>
              </div>
            </div>
            ${a}
          `}).join("")),this.updateCartSubtotal()}toggleSummaryPanel(){const t=this.classList.toggle("is-active");this.summaryControl.setAttribute("aria-expanded",t.toString())}updateTotal(){this.total=this._subtotal+this._shipping,this.cart.cartSubtotal=this._subtotal,this.cart.cartTotal=this.total,this._totalItems=this.cart.cartLines.length,this.renderTotal(),this.renderHeaderPrice()}renderTotal(){const t=this.querySelector('[js-product-summary="total-value"]');if(!t)return;let s=this.bundles.length>0?0:this.total;this.bundles.forEach(e=>s+=Number(e.price.amount)),this.variantUpsells.forEach(e=>s+=Number(e.price)/100),this.addOns.forEach(e=>s+=Number(e.price)),this.addOns2.forEach(e=>s+=Number(e.price)),t.textContent=n(s,!0,!1)}renderSubtotal(){const t=this.querySelector('[js-product-summary="subtotal-value"]');if(!t)return;let s=this.bundles.length>0?0:this._subtotal;this.bundles.forEach(e=>s+=Number(e.price.amount)),this.variantUpsells.forEach(e=>s+=Number(e.price)/100),this.addOns.forEach(e=>s+=Number(e.price)),this.addOns2.forEach(e=>s+=Number(e.price)),t.textContent=n(s,!0,!1)}renderItemsCount(){if(!this.itemsCount)return;const t=(this.bundles.length||1)+this.variantUpsells.length+this.addOns.length+this.addOns2.length;this.itemsCount.textContent=`(${t})`}renderHeaderPrice(){if(!this.headerPrice)return;let t=this.bundles.length>0?0:this.total;this.bundles.forEach(s=>t+=Number(s.price.amount)),this.variantUpsells.forEach(s=>t+=Number(s.price)/100),this.addOns.forEach(s=>t+=Number(s.price)),this.addOns2.forEach(s=>t+=Number(s.price)),t&&(this.headerPrice.textContent=n(t,!0,!1),this.stickyPrice&&(this.stickyPrice.textContent=n(t,!0,!1)))}addProductLine(t){this.cart.cartLines.push(t),this.updateCartSubtotal()}removeProductLine(t){this.cart.cartLines=this.cart.cartLines.filter(s=>s.id!==t),this.updateCartSubtotal()}updateCartSubtotal(){this._subtotal=this.cart.cartLines.reduce((t,s)=>t+s.price,0),this._subtotal+=this.variant?Number(this.variant.price):0,this.renderSubtotal(),this.renderItemsCount(),this.renderHeaderPrice(),this.updateTotal()}}customElements.define("uwp-product-summary",y);
